import { combineReducers } from '@reduxjs/toolkit';

import { globalNotificationSlice } from './globalNotificationSlice';

export const globalNotification = combineReducers({ apartaments: globalNotificationSlice.reducer });
